<template>
   <v-menu
      v-model="value"
      open-on-hover
      close-on-click
      close-on-content-click
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          v-on="on"
          block
          text
          class="buttonPluris"
          tile
          @click="callPagePluris(id, 0)"
        >
          {{ title }}
        </v-btn>
      </template>
      <v-list nav class="listPluris">
        <div
          v-for="(item, index) in items"
          :key="index"
        >
        <v-divider class="divider" v-if="index != 0" />
        <v-list-item @click="callPagePluris(id, index)">
          <v-list-item-title
           align="end"
          >{{ item.title }}</v-list-item-title>
        </v-list-item>
        </div>
      </v-list>
    </v-menu>
</template>

<script>
export default {
  name: 'MenuPluris',
  data: () => ({
    value: false,
  }),
  props: {
    title: {
      required: true,
      type: String,
      default: 'Menu',
    },
    items: {
      required: false,
      type: Array,
    },
    id: {
      required: true,
      type: Number,
      default: 1,
    },
  },
  methods: {
    callPagePluris(id, index) {
      this.$emit('callPage', { id, index });
    },
  },
};
</script>

<style scoped>
.buttonPluris {
  font-weight: 700;
  letter-spacing: 0;
  /* font-size: calc(5px + (20 - 5) * ((100vw - 300px) / (1920 - 300))); */
  font-size: 20px;
  justify-content: flex-end;
  margin-top: 10px;
  padding-right: 5vh !important;
}

.buttonPluris:hover {
  color: var(--v-secondary-base) !important;
  background-color: white;
}

.v-menu__content {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.theme--light.v-list {
  background: var(--v-secondary-base);
  cursor: pointer;
  border-radius: 0 0 0 0;
  width: 325px;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: white !important;
  text-transform: uppercase;
  font-weight: 700;
}

.v-list-item__title {
  /* font-size: calc(5px + (20 - 5) * ((100vw - 300px) / (1920 - 300))); */
  font-size: 20px;
  white-space: normal;
  margin-right: 40px;
  margin-left: 10px;
  padding: 10px;
}

.divider {
  background-color: white;
  height: 3px;
}

.v-list {
  padding: 0 0;
}
</style>
